import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';
import StrangerAccessPermissions, { IOrganizationInfo, StrangerOrganizationInfo } from 'src/app/core/models/stranger-permissions';
import { JoinOrganizationModalComponent, JoinOrganizationModalData } from '../join-organization-modal/join-organization-modal.component';
import { RegistrationRequestStatus } from 'src/app/core/models/registration-request-status';
import { CountriesResponse } from 'src/app/core/models/country';

@Component({
  selector: 'app-stranger-organizations',
  templateUrl: './stranger-organizations.component.html',
  styleUrls: ['./stranger-organizations.component.scss']
})
export class StrangerOrganizationsComponent {
  @Input() permissions: StrangerAccessPermissions = {} as StrangerAccessPermissions;
  @Input() countriesAll: CountriesResponse[] = [];

  @Output() switchOrganizationClicked: EventEmitter<IOrganizationInfo> = new EventEmitter<IOrganizationInfo>();
  @Output() joinOrganizationClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  displayedColumns: string[] = ['carrier', 'role', 'actions'];

  constructor(private translocoService: TranslocoService,
              public dialog: MatDialog
  ) { }

  getActiveLang() {
    return this.translocoService.getActiveLang();
  }

  getClientName(item: StrangerOrganizationInfo) {
    return this.getActiveLang() == 'ru' ? item.clientName : item.clientNameEn;
  }

  getRoleName(item: IOrganizationInfo) {
    return this.getActiveLang() == 'ru' ? item.role : item.roleEn;
  }

  onJoinOrganizationClick(item: StrangerOrganizationInfo) {
     const dialogData: JoinOrganizationModalData = {
        strangerInfo: item,
        phoneCountries: this.countriesAll
      }
    const dialogRef = this.dialog.open(JoinOrganizationModalComponent, {
      data: dialogData
    });

    dialogRef.afterClosed()
      .subscribe((result) => {
        if (result) {
          this.joinOrganizationClicked.emit();
        }
      });
  }

  onSwitchOrganizationClick(item: IOrganizationInfo) {
    this.switchOrganizationClicked.emit(item);
  }

  canJoinToOrganization(): boolean {
    return this.permissions.requests.some(
      (request) => {
        return request.requestNumber !== null &&
               request.requestNumber !== undefined &&
               request.requestNumber !== '' &&
               (request.status === RegistrationRequestStatus.ApprovedByChief ||
                request.status === RegistrationRequestStatus.ApprovedByController);
      }
    )
  }
}
